define('models/product_info',['require','backbone'],function (require) {
  var Backbone = require("backbone");

  return Backbone.Model.extend({
    url: function () {
      // set the endpoint for restful api for articles
      return this.id ? (App.Config.apiBase + "product-info/" + this.id + "/"): 
        (App.Config.apiBase + "product-info/");
    },

    defaults: function () {
      return { 
        id: null,
        product: null,
        key: ""
       };
    },
  });
});

